import { gql, TypedDocumentNode } from '@apollo/client';
import { take } from 'ramda';
import { compact } from '@moda/portal-stanchions';
import { VariantsQuery, VariantsQueryVariables } from '../generated/types';
import { VARIANT_CELL_FRAGMENT } from '../components/Grid';
import { useCountry } from '../components/CountrySelector';
import { logger } from '../lib/logger';
import { useSkippableQuery } from './useSkippableQuery';

const DEFAULT_LIMIT = 40;

export const VARIANTS_QUERY: TypedDocumentNode<VariantsQuery, VariantsQueryVariables> = gql`
  query VariantsQuery($ids: [String!], $countryCode: String) {
    variants(ids: $ids) {
      ...VariantCellFragment
    }
  }
  ${VARIANT_CELL_FRAGMENT}
`;

export const useVariantsQuery = ({
  variantIds,
  limit = DEFAULT_LIMIT,
  ssr = false
}: {
  variantIds?: string[] | null;
  limit?: number;
  ssr?: boolean;
}) => {
  const {
    country: { alpha3Code }
  } = useCountry();

  return useSkippableQuery(VARIANTS_QUERY, {
    variables: {
      ids: take(limit, compact(variantIds)),
      countryCode: alpha3Code
    },
    skip: !variantIds || variantIds.length === 0,
    ssr,
    onError: error => {
      logger.error('HANDLE_REQUEST', error?.message);
    }
  });
};
